import { DatePicker } from "antd";
import dayjs from "dayjs";

const ListMonthPicker = ({ title, value, onChange }) => (
  <DatePicker
    inputReadOnly
    picker="month"
    placeholder={title}
    format="MMMM YYYY"
    value={value ? dayjs(value) : null}
    onChange={onChange}
    style={{
      display: "block",
    }}
  />
);

export default ListMonthPicker;
